import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="SyHubDocs 文档与案例管理平台"
      links={[
        
      ]}
    />
  );
};

export default Footer;
